import(/* webpackMode: "eager", webpackExports: ["MobileHeader"] */ "/app/components/common/MobileHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BestSellers"] */ "/app/components/home/BestSellers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryCard"] */ "/app/components/home/CategoryCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/HeroSlide.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
